import { getAdminUserCourses, NetworkDTO, UserCoursesDTO } from '../../apis/api.signup'
import { useQuery } from 'react-query'
import { useUser } from '../../context/UserContext'

export const useCourses = () => {
    const { user } = useUser()

    const queryKey = ['My Admin Courses', user?._id ?? 'Unknown']

    const { data, ...rest } = useQuery({
        queryKey,
        queryFn: getAdminUserCourses,
        enabled: !!user,
    })

    // Flatten all courses from all networks for backwards compatibility
    const allCourses: UserCoursesDTO[] = data?.networks.reduce((acc, network) => [...acc, ...network.courses], []) ?? []

    // Get course data by courseId (cohortId)
    const getCourseData = (courseId: string) => allCourses.find((item) => item.courseId === courseId)
    // Get network data by networkId
    const getNetworkData = (networkId?: string) =>
        data?.networks.find((network) => network.networkId === networkId) || {
            networkId: undefined,
            networkName: '',
            courses: [],
        }   

    // Get all courses (cohorts) for a specific network
    const getCoursesByNetwork = (networkId: string) =>
        data?.networks.find((network) => network.networkId === networkId)?.courses ?? []

    return {
        networks: data?.networks ?? [],
        courses: allCourses, // For backwards compatibility
        getCourseData,
        getNetworkData,
        getCoursesByNetwork,
        ...rest,
    }
}

export const useMyCourse = (courseId?: string): UserCoursesDTO | undefined => {
    const { getCourseData } = useCourses()
    const course = courseId ? getCourseData(courseId) : undefined
    return course
}

export const useMyNetwork = (networkId?: string): NetworkDTO | undefined => {
    const { getNetworkData } = useCourses()
    const network = networkId ? getNetworkData(networkId) : undefined
    return network
}
